import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { HaveAccountWrapper, HaveAccountText, HaveAccountRedirect } from './AlreadyHaveAccount.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

export const AlreadyHaveAccount = observer('AlreadyHaveAccount', () => {
    const common = useCommon();
    const starRouter = StarRouter.get(common);

    return (
        <HaveAccountWrapper>
            <HaveAccountText data-test='have-account-text'>
                <I18n
                    langKey='signup-journey.footer.have-account'
                    defaultText='Already have an account?'
                />
            </HaveAccountText>

            <HaveAccountRedirect
                onClick={starRouter.redirectToLogin}
                dataTest='have-account-redirect'
            >
                <I18n
                    langKey='signup-journey.footer.login'
                    defaultText='Login'
                />
            </HaveAccountRedirect>
        </HaveAccountWrapper>
    );
});
